const translations: Record<string, string> = {
  // Navbar
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.custom': 'Custom Website',
  'nav.modules': 'Modules',
  'nav.brand': 'Brand Identity',
  'nav.contact': 'Contact',
  'nav.cta': 'Free Consultation',

  // Hero
  'hero.badge': 'Professional Digital Design Services',
  'hero.prefix': 'Crafted for Your',
  'hero.h0': 'Custom Website',
  'hero.h1': 'Brand Identity',
  'hero.h2': 'Module-Based Build',
  'hero.sub': 'We blend strategic thinking with refined aesthetics to create memorable digital experiences.',
  'hero.cta1': 'Explore Services',
  'hero.cta2': 'Free Consultation',
  'hero.stat0.sfx': '+',
  'hero.stat0.lbl': 'Successful Projects',
  'hero.stat1.sfx': '%',
  'hero.stat1.lbl': 'Client Satisfaction',
  'hero.stat2.sfx': '+',
  'hero.stat2.lbl': 'Years Experience',
  'hero.stat3.sfx': '+',
  'hero.stat3.lbl': 'Brand Clients',
  'hero.scroll': 'Scroll',

  // Services Section
  'svc.eyebrow': 'Our Services',
  'svc.title': 'Four Core Services',
  'svc.sub': 'From website design and module systems to brand building — a complete digital brand solution',
  'svc.c0.label': 'Custom Website',
  'svc.c0.title': 'Bespoke Web Development',
  'svc.c0.desc': 'From visual strategy to front-end development, we build custom responsive websites that perfectly reflect your brand.',
  'svc.c0.cta': 'Explore',
  'svc.c0.f0': 'Fully Custom Visual Design',
  'svc.c0.f1': 'Responsive & Cross-Device',
  'svc.c0.f2': 'SEO Technical Optimization',
  'svc.c0.f3': 'High-Performance Loading',
  'svc.c0.f4': 'Automated Security Testing',
  'svc.c1.label': 'Module Library',
  'svc.c1.title': 'Scalable UI Design System',
  'svc.c1.desc': 'Access over 130+ meticulously crafted UI components. Ready to use, ensuring consistency and accelerating development by 3x.',
  'svc.c1.cta': 'Browse Modules',
  'svc.c1.f0': '100+ Premium Components',
  'svc.c1.f1': 'Consistent Design System',
  'svc.c1.f2': 'Drag & Drop Assembly',
  'svc.c1.f3': 'Continuous Updates',
  'svc.c2.label': 'Brand Identity',
  'svc.c2.title': 'Brand Identity Design',
  'svc.c2.desc': 'Build a comprehensive visual system. From logo design to brand guidelines, we make your brand stand out.',
  'svc.c2.cta': 'Learn More',
  'svc.c2.f0': 'Creative Logo Design',
  'svc.c2.f1': 'Color & Typography System',
  'svc.c2.f2': 'Brand Application Design',
  'svc.c2.f3': 'Full VI Guidelines',
  'svc.c3.label': 'SEO & Marketing',
  'svc.c3.title': 'SEO & Digital Marketing',
  'svc.c3.desc': 'Combining strategic content and technical SEO to improve rankings, attract qualified traffic, and increase conversions.',
  'svc.c3.cta': 'Learn More',
  'svc.c3.f0': 'Keyword Strategy',
  'svc.c3.f1': 'Core Web Vitals',
  'svc.c3.f2': 'Content Marketing',
  'svc.c3.f3': 'Analytics & Reporting',
  'svc.qa.eyebrow': 'Our Commitment to Quality',
  'svc.qa.title': 'Ensuring stability, security, and performance across all our digital solutions.',
  'svc.qa.sub': 'Automated precision meets human expertise. We rigorously validate every detail to ensure maximum stability and zero-risk deployments.',
  'svc.qa0.title': '1,200+ Test Cases',
  'svc.qa0.text': 'Automated scripts cover every feature module, ensuring every update is rock-solid',
  'svc.qa1.title': 'Zero-Risk Launch',
  'svc.qa1.text': 'Full OWASP vulnerability scanning ensures your site is completely secure before going live',
  'svc.qa2.title': 'Performance Stress Test',
  'svc.qa2.text': 'Simulates peak traffic to ensure your site stays fast and stable under any load',
  'svc.qa3.title': '8 Dedicated QA Engineers',
  'svc.qa3.text': 'Senior QA engineers sign off on every delivery — uncompromising quality guaranteed',

  // Custom Website Section
  'cw.eyebrow': 'Custom Website',
  'cw.titleL1': 'Bespoke Digital Experiences',
  'cw.titleL2': '',
  'cw.sub': 'Your brand deserves more than a template. From the first line of code to the final pixel, we engineer bespoke websites that perfectly capture your unique identity.',
  'cw.badge.label': 'Average Delivery',
  'cw.badge.value': 'Live in 8 Weeks',
  'cw.f0.title': 'Fully Custom Visual Design',
  'cw.f0.desc': 'Crafted to match your brand\'s exact tone and vision. No templates, zero compromises',
  'cw.f1.title': 'Responsive & Cross-Device',
  'cw.f1.desc': 'Flawless performance across mobile, tablet, and desktop screens',
  'cw.f2.title': 'SEO Technical Optimization',
  'cw.f2.desc': 'Core Web Vitals compliant, built to rank higher and drive organic traffic',
  'cw.f3.title': 'High-Performance Loading',
  'cw.f3.desc': 'Optimized code and media for lightning-fast page speeds',
  'cw.f4.title': 'Custom CMS Integration',
  'cw.f4.desc': 'Intuitive backend systems for seamless content updates',
  'cw.f5.title': 'Security & Maintenance',
  'cw.f5.desc': 'Enterprise-grade SSL, regular backups, and ongoing technical support',
  'cw.f6.title': 'Professional Automated Testing',
  'cw.f6.desc': 'Rigorous pre-launch validation ensuring absolute stability and zero-risk deployment.',
  'cw.f6.badge': 'Key Advantage',
  'cw.qa.eyebrow': 'Quality Assurance',
  'cw.qa.badge': 'Quality Assurance',
  'cw.qa.titleL1': 'Every Website Goes Through',
  'cw.qa.titleL2': 'Professional Automated Testing',
  'cw.qa.desc': 'Our dedicated QA engineering team uses a fully automated testing pipeline for multi-layer verification — functional testing, security scanning, and performance load testing — so your site launches in the most stable and secure state possible.',
  'cw.qs0.label': 'Automated Test Cases',
  'cw.qs1.label': 'Pre-Launch Security Scan',
  'cw.qs2.label': 'Known Vulnerabilities at Launch',
  'cw.qs3.label': 'Dedicated QA Engineers',
  'cw.tl.title': 'Structured Delivery Process',
  'cw.tl.sub': 'A transparent 8-week journey. You stay informed and in control at every milestone.',
  'cw.tl0.week': 'Week 1-2',
  'cw.tl0.phase': 'Discovery',
  'cw.tl0.desc': 'Uncovering your brand\'s core value through deep market research and strategic positioning',
  'cw.tl1.week': 'Week 3–4',
  'cw.tl1.phase': 'Visual Design',
  'cw.tl1.desc': 'Translating strategy into aesthetics. We iterate through design concepts until perfectly aligned with your vision',
  'cw.tl2.week': 'Week 5–7',
  'cw.tl2.phase': 'Development',
  'cw.tl2.desc': 'Bringing designs to life with robust code, seamless CMS integration, and meticulous performance tuning',
  'cw.tl3.week': 'Week 8',
  'cw.tl3.phase': 'Launch',
  'cw.tl3.desc': 'Executing a flawless, zero-risk deployment, complete with comprehensive training and ongoing support',

  // Module Library
  'mod.eyebrow': 'Module Library',
  'mod.title': 'Professional Module Library',
  'mod.sub': 'Over 130 premium UI components across 6 categories. Engineered for rapid assembly while maintaining flawless design consistency.',
  'mod.hint': 'Hover over cards to see module details',
  'mod.c0.name': 'Layout Components',
  'mod.c0.desc': 'Hero banners, content grids, and flexible dividers — the fundamental building blocks for robust page structures.',
  'mod.c0.unit': 'modules',
  'mod.c0.i0': 'Hero Banners × 8',
  'mod.c0.i1': 'Page Layouts × 6',
  'mod.c0.i2': 'Content Grids × 5',
  'mod.c0.i3': 'Split Screens × 5',
  'mod.c1.name': 'Navigation',
  'mod.c1.desc': 'Intuitive top navs, sidebars, and mega-menus designed to guide users seamlessly through your digital experience.',
  'mod.c1.unit': 'modules',
  'mod.c1.i0': 'Top Nav × 6',
  'mod.c1.i1': 'Hamburger Menu × 4',
  'mod.c1.i2': 'Sidebar Nav × 4',
  'mod.c1.i3': 'Breadcrumbs × 4',
  'mod.c2.name': 'E-Commerce',
  'mod.c2.desc': 'Conversion-optimized product cards, dynamic shopping carts, and streamlined checkout flows to maximize sales.',
  'mod.c2.unit': 'modules',
  'mod.c2.i0': 'Product Cards × 10',
  'mod.c2.i1': 'Shopping Cart × 5',
  'mod.c2.i2': 'Checkout Steps × 6',
  'mod.c2.i3': 'Product Details × 9',
  'mod.c3.name': 'Form Controls',
  'mod.c3.desc': 'Interactive input fields, smart dropdowns, and multi-step forms engineered for high-converting data collection.',
  'mod.c3.unit': 'modules',
  'mod.c3.i0': 'Text Inputs × 6',
  'mod.c3.i1': 'Dropdowns × 5',
  'mod.c3.i2': 'File Upload × 4',
  'mod.c3.i3': 'Multi-Step Forms × 7',
  'mod.c4.name': 'Media Display',
  'mod.c4.desc': 'Immersive image galleries, dynamic carousels, and custom video players to bring your visual assets to life.',
  'mod.c4.unit': 'modules',
  'mod.c4.i0': 'Image Galleries × 7',
  'mod.c4.i1': 'Video Players × 4',
  'mod.c4.i2': 'Carousels × 5',
  'mod.c4.i3': 'Lightbox × 4',
  'mod.c5.name': 'Data Visualization',
  'mod.c5.desc': 'Elegant charts, interactive dashboards, and real-time KPI cards for crystal-clear business intelligence.',
  'mod.c5.unit': 'modules',
  'mod.c5.i0': 'Charts × 6',
  'mod.c5.i1': 'Progress Bars × 4',
  'mod.c5.i2': 'Dashboards × 3',
  'mod.c5.i3': 'KPI Cards × 3',
  'mod.apply': 'Apply for This Module',
  'mod.cta.title': 'Need a Custom Solution?',
  'mod.cta.sub': 'Share your specific requirements. Our team will engineer a bespoke module tailored to your exact needs',
  'mod.cta.btn': 'Request Custom Module',

  // Brand Identity
  'br.eyebrow': 'Brand Identity',
  'br.title': 'Crafting Iconic Brands',
  'br.sub': "A brand is more than just visuals — it's the strategic expression of your core identity. We engineer cohesive visual systems that leave a lasting impression.",
  'br.c0.title': 'Creative Logo Design',
  'br.c0.desc': 'We distill your brand\'s core values into a powerful, recognizable emblem. Engineered to scale perfectly across all mediums.',
  'br.c0.f0': 'Multiple Concept Proposals',
  'br.c0.f1': 'Vector Format Delivery',
  'br.c0.f2': 'B&W and Color Variations',
  'br.c0.f3': 'Structured Revision Rounds',
  'br.c1.title': 'Visual Identity System',
  'br.c1.desc': 'Systematically defining your color palettes, typography, and visual assets to guarantee flawless consistency across every touchpoint.',
  'br.c1.f0': 'Brand Color Guidelines',
  'br.c1.f1': 'Typography System',
  'br.c1.f2': 'Custom Graphic Elements',
  'br.c1.f3': 'Comprehensive VI Guidelines',
  'br.c2.title': 'Brand Application Design',
  'br.c2.desc': 'Translating your identity into tangible assets. From digital templates to premium print collateral, we ensure your brand shines everywhere.',
  'br.c2.f0': 'Premium Stationery Design',
  'br.c2.f1': 'Presentation Templates',
  'br.c2.f2': 'Social Media Assets',
  'br.c2.f3': 'Marketing Collateral',
  'br.proc.eyebrow': 'Our Process',
  'br.proc.title': 'Four-Step Brand Design Process',
  'br.proc.sub': 'A rigorous, strategy-first approach designed to transform your core vision into an iconic visual identity.',
  'br.proc0.title': 'Brand Research',
  'br.proc0.desc': "Uncovering your brand's DNA. We analyze your market, audience, and competition to build a bulletproof strategic foundation",
  'br.proc1.title': 'Concept Development',
  'br.proc1.desc': 'Translating insights into aesthetics. We explore distinct design directions through curated mood boards and conceptual sketches',
  'br.proc2.title': 'Design Refinement',
  'br.proc2.desc': "Perfecting the vision. Through structured revision rounds, we meticulously polish the chosen concept until it embodies your brand's soul",
  'br.proc3.title': 'Brand Delivery',
  'br.proc3.desc': 'Equipping you for the future. We deliver comprehensive asset libraries and precise guidelines to ensure flawless brand execution',
  'br.proc.cta': 'Start Your Brand Project',

  // Contact
  'ct.eyebrow': 'Contact Us',
  'ct.title': 'Start Your Project',
  'ct.sub': "Share your vision with our team. We'll review your requirements and respond within one business day to discuss your next steps",
  'ct.info0.label': 'Address',
  'ct.info0.value': 'No.7 Xinyi Rd Sec.5, Xinyi Dist., Taipei',
  'ct.info1.label': 'Email',
  'ct.info1.value': 'info@forwardthai.com',
  'ct.info2.label': 'Phone',
  'ct.info2.value': '+886 2 2345 6789',
  'ct.info3.label': 'Hours',
  'ct.info3.value': 'Mon–Fri, 9:00–18:00',
  'ct.social.title': 'Follow Us',
  'ct.form.nameLabel': 'Name *',
  'ct.form.emailLabel': 'Email *',
  'ct.form.serviceLabel': 'Service Type',
  'ct.form.budgetLabel': 'Budget Range',
  'ct.form.messageLabel': 'Project Description',
  'ct.form.namePlaceholder': 'Your name',
  'ct.form.emailPlaceholder': 'your@email.com',
  'ct.form.msgPlaceholder': 'Describe your project requirements, goals, and any special requests...',
  'ct.form.svcDefault': 'Select a service',
  'ct.form.svc0': 'Custom Website Design',
  'ct.form.svc1': 'Brand Identity Design',
  'ct.form.svc2': 'Module Library',
  'ct.form.svc3': 'SEO Optimization',
  'ct.form.svc4': 'Other',
  'ct.form.bgtDefault': 'Select a budget range',
  'ct.form.bgt0': 'Under $1,500',
  'ct.form.bgt1': '$1,500 – $5,000',
  'ct.form.bgt2': '$5,000 – $10,000',
  'ct.form.bgt3': 'Over $10,000',
  'ct.form.submit': 'Submit Inquiry',
  'ct.form.submitting': 'Submitting...',
  'ct.form.successTitle': 'Inquiry Received',
  'ct.form.successDesc': 'Thank you for reaching out. Our team will review your project details and connect with you within one business day.',
  'ct.form.refill': 'Return to Home',
  'ct.form.error': 'Submission failed. Please try again later.',

  // Footer
  'ft.desc': 'Your digital creative partner for enterprise brand design, crafting unique digital identities with refined design.',
  'ft.group0.title': 'Services',
  'ft.group0.l0': 'Custom Website Design',
  'ft.group0.l1': 'Brand Identity',
  'ft.group0.l2': 'Module Library',
  'ft.group0.l3': 'SEO Marketing',
  'ft.group0.l4': 'Website Maintenance',
  'ft.group1.title': 'Resources',
  'ft.group1.l0': 'Design Blog',
  'ft.group1.l1': 'Module Preview',
  'ft.group1.l2': 'Design Guide',
  'ft.group1.l3': 'Case Studies',
  'ft.group1.l4': 'FAQ',
  'ft.group2.title': 'About Us',
  'ft.group2.l0': 'Our Story',
  'ft.group2.l1': 'Design Philosophy',
  'ft.group2.l2': 'Team',
  'ft.group2.l3': 'Careers',
  'ft.group2.l4': 'Contact',
  'ft.legal0': 'Privacy Policy',
  'ft.legal1': 'Terms of Service',
  'ft.legal2': 'Cookie Settings',
  'ft.tagline': 'Professional Digital Design Services',
  'ft.backtop': 'Back to Top',
};
export default translations;
